import { render } from "./CatalogoPerfilDePermissao.vue?vue&type=template&id=6ee2a09b&ts=true"
import script from "./CatalogoPerfilDePermissao.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogoPerfilDePermissao.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src-next/modulos/governanca/perfil-de-permissao/catalogo/apresentacao/CatalogoPerfilDePermissao.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ee2a09b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ee2a09b', __exports__)) {
    api.reload('6ee2a09b', __exports__)
  }
  
  module.hot.accept("./CatalogoPerfilDePermissao.vue?vue&type=template&id=6ee2a09b&ts=true", () => {
    api.rerender('6ee2a09b', render)
  })

}


export default __exports__